













































  type Social = { title : string, url : string }
  type Data = { links : Social[] }

  export default {
  name: 'Home',
  data() : Data {
    return { 
      links : [
        { 
          title: "LinkedIn",
          url: "https://pl.linkedin.com/in/mateusz-bujalski-75465b51"
        },
        {
          title: "Github",
          url: "https://github.com/mateuszbujalski"
        }
      ]
    }
  }
}
